<template>
  <b-modal id="bv-modal-columns"
           size="big"
           @hide="onHide"
           @ok="onOk"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>
    <div class="d-block">
      <div class="container" style="max-width: 95vw;">
        <div class="row">
          <div class="col-12">
            <div class="column-wrapper"
                 @touchend="onTouchDropEnd($event)"
                 @drop="onDrop($event)"
                 @dragover.prevent
                 @dragenter.prevent>
              <template v-for="(col, index) in newCols" :index="index">
                <div class="column-item" v-for="(x, index) in col" :index="index">
                  <div
                      class="draggable-item custom-control custom-checkbox text-left"
                      v-for="y in x" :key="y.colId"
                      draggable="true"
                      @dragstart="onDragStart($event, y, index)"
                      @dragover="onDragOver($event, y, index)"
                      @dragleave="onDragLeave($event)"
                      @dragenter="onDragEnter($event)"
                      @touchstart="onTouchStart($event, x, index)"
                      @touchend="onTouchEnd($event)"
                      @touchmove="onTouchMove($event)"
                  >
                    <div class="draggable-item-inner">
                      <font-awesome-icon icon="grip-lines" transform="" style="margin-top: 2px"></font-awesome-icon>
                      <div class="checkbox-container">
                        <input type="checkbox" :name="y.colId" :id="y.colId" class="custom-control-input" v-model="y.visible">
                        <label :for="y.colId" class="custom-control-label">{{y.colLabel}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="v3Grig">
        <div class="col-12 mb-1">
          Pinned columns
        </div>
        <div class="col-6">
          <b-form-select v-model="pinnedCols" :options="filteredPinnedOptions"></b-form-select>
        </div>
      </div>

    </div>

    <template #modal-footer="{close}">
      <div class="container" style="max-width: 95vw">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="column-dialog-links">
              <b-btn variant="plm-link" class="text-left" role="button" @click="resetCols">Reset columns</b-btn>
              <b-btn variant="plm-link" class="text-left" role="button" @click="hideAll">Hide all columns</b-btn>
              <b-btn v-if="checkIsCordova" variant="plm-link" class="text-left" role="button" @click="blockMovement">
                {{ blockColumnMovement ? $tr('unlock','Unlock') : $tr('block','Block') }}
                columns movement</b-btn>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="column-dialog-btns">
              <b-button
                  variant="plm-secondary"
                  @click="onHide"
              >
                <font-awesome-icon icon="times"></font-awesome-icon>
                Cancel
              </b-button>
              <b-button
                  variant="plm-success"
                  @click="onOk"
              >
                <font-awesome-icon icon="check"></font-awesome-icon>
                Apply selection
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>


import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";

export default {
  name: "ColumnsDialog",
  async beforeMount() {

  },
  computed: {
    checkIsCordova() {
      return window.isCordova;
    },
    filteredPinnedOptions() {
      if (!this.checkIsCordova) {
        return this.pinnedOptions;
      } else {
        return this.pinnedOptions.slice(0, 3);
      }
      }
  },
  methods: {


    // ---------------- ON DROP -> MOBILE ----------------
    onTouchDropEnd(event) {
      if(!this.blockColumnMovement && this.lastOnOverElement && this.targetElementTemp) {
        event.preventDefault();
        this.onDrop(event);
      }
    },

    // ---------------- TOUCH EVENTS -> MOBILE ----------------

    onTouchStart(event, items, index) {
      if(!this.blockColumnMovement) {

        const touch = event.touches[0];
        this.draggedElement = event.target;
        this.isDragging = true;

        this.draggedElement.initialTouchX = touch.clientX;
        this.draggedElement.initialTouchY = touch.clientY;

        this.draggedElementOriginColumnIndex = index;

        const clientX = touch.clientX;
        const clientY = touch.clientY;
        const targetElement = document.elementFromPoint(clientX, clientY);

        for (let item of items) {
          if (targetElement.textContent === item.colLabel) {
            this.itemData = item;
          }
        }
      }
    },
    onTouchEnd(event){
      if(!this.blockColumnMovement) {

        event.target.classList.remove('light-blue-bg');

        if (!this.isDragging) return;

        this.draggedElement.style.transform = '';
        this.draggedElement = null;
        this.isDragging = false;
      }
    },
    onTouchMove(event){
      if(!this.blockColumnMovement) {

        event.preventDefault();
        if (!this.isDragging) return;

        const touch = event.touches[0];
        const deltaX = touch.clientX - this.draggedElement.initialTouchX;
        const deltaY = touch.clientY - this.draggedElement.initialTouchY - 30;

        this.draggedElement.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

        const clientX = touch.clientX;
        const clientY = touch.clientY;
        this.onTouchOver(event, clientX, clientY);
      }
    },
    onTouchOver(event, clientX, clientY) {
      if(!this.blockColumnMovement) {

        event.preventDefault();

        const targetElement = document.elementFromPoint(clientX, clientY);
        if (targetElement && this.targetElementTemp && this.targetElementTemp !== targetElement) {
          this.targetElementTemp.classList.remove('light-blue-bg');
          targetElement.classList.add('light-blue-bg');
          this.targetElementTemp = targetElement;
        } else {
          this.targetElementTemp = targetElement;
        }

        this.newCols.forEach(colArray => {
          colArray.forEach((col, colIndex) => {
            col.forEach(item => {
              if (targetElement && targetElement.textContent === item.colLabel) {
                this.onDragOver(event, item, colIndex);
              }
            });
          });
        });
      }
    },

    // ---------------- DROP EVENTS -> WEB ----------------

    onDragStart(event, item, index) {
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      this.draggedElementOriginColumnIndex = index;

      //save just dragged object
      // event.dataTransfer.setData('item', JSON.stringify(item));
      this.itemData = item;

    },
    onDragEnter(event) {
      event.target.classList.add('light-blue-bg');
    },
    onDragOver(event, item, index) {
      this.lastOnOverColumnIndex = index;
      this.lastOnOverElement = item;
    },
    onDragLeave(event) {
      event.target.classList.remove('light-blue-bg');
    },

    // ---------------- ON DROP ----------------

    onDrop(event) {
      event.target.classList.remove('light-blue-bg');

      if (this.targetElementTemp)
        this.targetElementTemp.classList.remove('light-blue-bg');

      //read just dragged object
      // const draggedObj = JSON.parse(event.dataTransfer.getData('item'));
      const draggedObj = this.itemData;
      const colTargetData = this.newCols[0][this.lastOnOverColumnIndex];
      this.lastOnOverElementIndex = colTargetData.indexOf(this.lastOnOverElement);

      const colOriginData = this.newCols[0][this.draggedElementOriginColumnIndex];
      //remove just dragged element from origin arr
      let filteredList = colOriginData.filter(el => el.colId !== draggedObj.colId);

      //columns containing the new order
      const recalculatedCols = [];

      //recalculate columns
      if(this.draggedElementOriginColumnIndex === this.lastOnOverColumnIndex) {
        //sort list by new order

        this.newCols[0].forEach((col, index) => {
          if(index === this.draggedElementOriginColumnIndex) {
            col = filteredList;
            col.splice(this.lastOnOverElementIndex, 0, draggedObj);
            recalculatedCols.push(col);
          } else {
            recalculatedCols.push(col);
          }
        })

      } else {
        //move an element between list

        this.newCols[0].forEach((col, index) => {
          if(index === this.draggedElementOriginColumnIndex) {
            recalculatedCols.push(filteredList);
          } else {
            //build new col and splice element
            if(index === this.lastOnOverColumnIndex) {
              col.splice(this.lastOnOverElementIndex, 0, draggedObj);
              recalculatedCols.push(col);
            } else {
              recalculatedCols.push(col);
            }
          }
        })
      }

      let counter = 1;
      recalculatedCols.forEach(arr =>
          arr.forEach(obj => {
            obj.order = counter++;
          })
      );

      // console.log('recalculatedCols: ', recalculatedCols);
      this.newCols = [recalculatedCols];
      this.lastOnOverColumnIndex = null;
      this.lastOnOverElement = null;
    },
    async onOk(ev) {
      if (this.resolve != null) {

        this.resolve(null);
        this.resolve = null;
      }
      let vData = {};
      // this.cols.forEach(c => {
      let orderData = {};
      //   vData[c.colId] = c.visible;
      // });

      let order = 1;
      this.newCols.forEach(c =>
          c.forEach(x =>
              x.forEach(y => {
                vData[y.colId] = y.visible
                orderData[y.colId] = order;
                order++;
              })
          )
      )
      // console.log('vDat:', vData);
      this.columnsManager.setColumnsVisibility(vData, orderData, this.pinnedCols);
      this.$bvModal.hide("bv-modal-columns");
    },
    blockMovement(){
      this.blockColumnMovement = !this.blockColumnMovement;
    },
    hideAll() {
      let vData = {};
      // this.cols.forEach(c => {
      //     vData[c.colId] = false;
      // });
      // console.log('vData:', vData)
      // this.columnsManager.setColumnsVisibility(vData);
      // this.$bvModal.hide("bv-modal-columns");

      this.newCols.forEach(c =>
          c.forEach(x =>
              x.forEach(y => vData[y.colId] = false)
          )
      )
      // console.log('vData:', vData)
      this.columnsManager.setColumnsVisibility(vData);
      this.$bvModal.hide("bv-modal-columns");
    },
    resetCols() {
      this.columnsManager.resetConfig();
      this.columnsManager.resetConfigForDynamicColumns();
      this.$bvModal.hide("bv-modal-columns");
    },
    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
      this.$bvModal.hide("bv-modal-columns");
    },

    /**
     * @param {DataGrid2} dataGrid
     */
    setDataGrid(dataGrid) {
      this.v3Grig = SessionManager.hasFlag(FeatureFlag.GRID_V3);
      /** @type {DataGrid2} */
      this.dataGrid = dataGrid;
      /** @type {ColumnsManager} */
      this.columnsManager = this.dataGrid._getColumnsManager();
      /** @type {ColVisibility[]} */
      this.cols = this.columnsManager.getColumnsVisibility();
      this.pinnedCols = this.columnsManager.config.pinnedCols ?? 0;

      // console.log('COLS: ', this.cols);
      // this.splitData(this.cols, 19);
      this.splitData(this.cols, (this.cols.length / this.numberOfChunks));
    },
    reset() {
      this.resolve = null;
      this.columnsManager = null;
      this.dataGrid = null;
      this.cols = [];
      this.newCols = [];
    },
    splitData(array, size) {
      this.chunks = [];
      for (let i = 0; i < array.length; i += size) {
        let chunk = array.slice(i, i + size);
        this.chunks.push(chunk);
      }
      this.newCols.push(this.chunks);
    }
  },
  data: () => ({
    v3Grig: SessionManager.hasFlag(FeatureFlag.GRID_V3),
    pinnedOptions: [
      {value:0, text: $tr("noPinned","No pinned columns")},
      {value:1, text: $tr("onePinned","1 pinned column")},
      {value:2, text: $tr("twoPinned","2 pinned columns")},
      {value:3, text: $tr("threePinned","3 pinned columns")},
    ],

    pinnedCols: 0,
    title: "Select visible columns",
    resolve: null,
    /** @type {ColVisibility[]} */
    cols: [],
    chunks: [],
    newCols: [],
    numberOfChunks: 5,
    draggedElementOriginColumnIndex: null,
    itemData: null,
    lastOnOverElement: null,
    lastOnOverColumnIndex: null,
    lastOnOverElementIndex: null,
    targetElementTemp: null,
    blockColumnMovement: false,
  })
}
</script>

<style scoped>

label.light-blue-bg {
  background: linear-gradient(90deg, #d6e8ff 0%, #bfeaff 100%);
}

.column-wrapper {
  display: flex;
  overflow: auto;
  min-height: 50px;
}

.column-item {
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.draggable-item:last-of-type {
  position: relative;
  flex: 1;
  align-self: stretch
}

.draggable-item-inner {
  display: flex;
  align-items: center;
}

.checkbox-container {
  padding-left: 35px;
  width: 100%;
  position: relative;
}

.custom-control-input:checked ~ .custom-control-label::before, .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  top: 52%;
  transform: translateY(-50%);
}

.custom-control-input ~ .custom-control-label::before, .custom-checkbox .custom-control-input ~ .custom-control-label::after {
  top: 52%;
  transform: translateY(-50%);
}

.custom-control-input ~ .custom-control-label::before, .custom-checkbox .custom-control-input ~ .custom-control-label::after {
  top: 52%;
  transform: translateY(-50%);
}

.checkbox-container label {
  padding-top: 8px;
  padding-bottom: 8px;
  width: 100%;
  line-height: 20px;
  cursor: pointer;
}

.column-dialog-links {
  display: flex;
  justify-content: space-evenly;
}

.column-dialog-btns {
  display: flex;
  justify-content: space-evenly;
  margin-top: 13px;
}

@media only screen and (max-width: 600px) {
  .column-item {
    min-width: 80%
  }
}

@media only screen and (min-width: 600px) {
  .column-item {
    min-width: 80%
  }
}

@media only screen and (min-width: 768px) {
  .column-item {
    min-width: 50%
  }

  .column-dialog-links {
    justify-content: flex-start;
  }

  .column-dialog-btns {
    margin-top: 0;
    justify-content: flex-end;
  }

  .column-dialog-btns button {
    margin-left: 10px;
  }
}

@media only screen and (min-width: 992px) {
  .column-item {
    min-width: 20%
  }
}

@media only screen and (min-width: 1200px) {
  .column-item {
    min-width: 20%
  }
}


</style>